import { createContext, useContext } from "react";

import type {
  Booking,
  BookingConfiguration,
} from "~/providers/booking-provider";

interface BookingContext {
  bookings: Booking[];
  bookingConfiguration?: BookingConfiguration;
  fetchBookings: () => Promise<boolean>;
}

export const BookingContext = createContext<BookingContext | undefined>(
  undefined,
);

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error(
      "useBookings must be used within a BookingProvider, but no provider was found",
    );
  }

  return context;
};
